import React from 'react'

const Application = () => {
  return (
    <div>Application</div>
  )
}

export default Application